import DrivingGameList from './DrivingGameList.vue';
import DrivingGame from './DrivingGame.vue';

export default {
  DrivingGameList,
  DrivingGame,
};
